/* eslint-disable react-hooks/rules-of-hooks */
/*
 * @Author: zwh2 zwh2@meitu.com
 * @Date: 2025-05-21 21:31:29
 * @LastEditors: chenhe ch10@meitu.com
 * @LastEditTime: 2025-09-26 16:22:48
 * @FilePath: /roboneo-web/src/pages/--roboneo/index.page.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState } from 'react';
import Head from 'next/head';
import { defineNextPage } from '@/common/next';
import PartnerLogos from '@/components/overseaHome/ui/PartnerLogos';
import FeatureShowcase from '@/components/overseaHome/ui/FeatureShowcase';
import type { ActivityItem, OverseaFeatureItem } from '@/apiSdk/api.type';
import CapabilitiesOverview from '@/components/overseaHome/ui/CapabilitiesOverview';
import MainScreen from '@/components/overseaHome/ui/MainScreen';
import { fetchActivityList, fetchOverseaMenus } from '@/apiSdk/serverRquest';
import Pricing from '@/components/overseaHome/ui/Pricing';
import FeedbackOverview from '@/components/overseaHome/ui/FeedbackOverview';
import CaseList from '@/components/overseaHome/ui/CaseList';
import TopAlert from '@/components/overseaHome/ui/TopAlert';
import Header from '@/components/overseaHome/layout/header';
import StartCreationBanner from '@/components/overseaHome/ui/StartCreationBanner';
import NextScript from 'next/script';
import { Footer } from '@/components/overseaHome/layout';
import { isMobile } from '@/utils';
import { OVERSEA_CANONICAL_URL, HREFLANG_ALTERNATES } from './seo';
import style from './index.module.scss';

export default defineNextPage<{
  title: string;
  menus: Record<'product' | 'blog', OverseaFeatureItem[]>;
  activityList: ActivityItem[];
  countryCode: string;
  userAgent: string;
}>({
  pageConfig: {
    projectId: '/--oversea',
    layoutId: 'OverseaLayout',
    renderHead({ pageProps }) {
      return (
        <Head>
          <title>{pageProps.title}</title>
          <meta name="description" content="这是描述" />
          {/* Canonical 与 hreflang 优化 SEO：多语言/地区正确索引 */}
          <link rel="canonical" href={OVERSEA_CANONICAL_URL} />
          {HREFLANG_ALTERNATES.map(({ hreflang, href }) => (
            <link
              key={hreflang}
              rel="alternate"
              hrefLang={hreflang}
              href={href}
            />
          ))}
        </Head>
      );
    },
  },
  async getInitialProps(context) {
    const cookie = context.req?.headers.cookie;
    // 从 server.ts 中挂载到 req 上的 countryCode
    const countryCode = ((context.req as any)?.countryCode as string) || '';
    const requestOptions = { cookie, countryCode };

    console.log('[请求首页数据] 开始');
    // 并行请求，互不影响
    const [activityData, menus] = await Promise.all([
      fetchActivityList('official_home_top', requestOptions).catch(() => null),
      fetchOverseaMenus(requestOptions).catch(() => ({ list: [] })),
    ]);
    const productMenus = menus.list.filter((item) => item.category === 'Product')[0];
    const blogMenus = menus.list.filter((item) => item.category === 'Blog')[0];
    const productFilteredMenus = productMenus?.list ?? [];
    const blogFilteredMenus = blogMenus?.list ?? [];
    console.log('activityData', JSON.stringify(activityData));
    console.log('productMenus', JSON.stringify(productFilteredMenus));
    console.log('blogMenus', JSON.stringify(blogFilteredMenus));
    console.log('[请求首页数据] 结束');

    // 获取浏览器信息
    const userAgent = context.req?.headers['user-agent'] || '';
    return {
      title: '首页',
      menus: { product: productFilteredMenus, blog: blogFilteredMenus },
      activityList: activityData?.list ?? [],
      countryCode,
      userAgent,
    };
  },
  component: ({
    title,
    menus,
    activityList,
    userAgent,
    countryCode,
  }) => {
    const [isJSMpegLoaded, setIsJSMpegLoaded] = useState(false);
    const isPhone = isMobile(userAgent);
    console.log('isPhone', isPhone);

    const onJSMpegLoad = () => {
      console.log('jsmpeg.min.js loaded');
      setIsJSMpegLoaded(true);
    };

    return (
      <div className={style.container}>
        { isPhone && !isJSMpegLoaded && <NextScript src="https://titan-img.meitudata.com/xiuxiu/h5/city-travel/js/jsmpeg.min.js" onLoad={onJSMpegLoad} />}
        <Header showAlert={activityList.length > 0} menus={menus} />
        {/* 顶部alter横幅 */}
        {activityList.length > 0 && <TopAlert activityList={activityList} />}
        {/* 首屏 */}
        <MainScreen isJSMpegLoaded={isJSMpegLoaded} isPhone={isPhone} />
        {/* 合作伙伴 */}
        <PartnerLogos />
        {/* 功能展示 */}
        <FeatureShowcase isJSMpegLoaded={isJSMpegLoaded} />
        {/* 案例列表 */}
        <CaseList />
        {/* 能力概览 */}
        {menus?.product?.length > 0 && <CapabilitiesOverview productMenus={menus.product} />}
        {/* 价格 */}
        <Pricing />
        {/* 反馈概览 */}
        <FeedbackOverview />
        {/* 开始创作横幅 */}
        <StartCreationBanner />
        {/* 页尾 */}
        <Footer countryCode={countryCode} />
      </div>
    );
  },
});
